<template>
  <div class="header">
    <div v-if="showNavBar" class="wrapper">
      <img
        :src="selectedLogo"
        @error="handleImageError"
        alt="Calculator power"
        :class="calculatorData.isTata ? 'tata_image' : 'diffOrgLogo'"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { solarCalculatorStore } from '../../store/solarCalculator';
import { blobUrl } from '../../../constants';

const props = defineProps({
  showNavBar: Boolean,
});

const store = solarCalculatorStore();
const calculatorData = store.CALCULATOR_DATA_STATE;

const diffOrgLogo = blobUrl + calculatorData.orgName + "_logo.jpg";
const tataLogo = blobUrl + "tata_logo.jpg";
const defaultLogo = "https://downloadtsl.blob.core.windows.net/logos/Arka%20Logo%20-%20Black.png";

const selectedLogo = computed(() => {
  if (!calculatorData.isTata) {
    return diffOrgLogo;
  } else if (calculatorData.orgName === 'tata' || calculatorData.orgName === 'tataFromMarketing') {
    return tataLogo;
  }
  return defaultLogo;
});

const handleImageError = (e) => {
  e.target.src = defaultLogo;
};
</script>

<style scoped>
.wrapper {
  display: flex;
  height: 9.8vh;
  padding: 16px 24px;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid var(--White, #fff);
  background: var(--White, #fff);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.25);
}

.tata_image,
.diffOrgLogo {
  max-width: 240px;
  height: 35px;
  flex-shrink: 0;
}

.diffOrgLogo {
  max-height: 50px;
}

@media (max-width: 1180px) {
  .wrapper {
    height: 65px;
  }
}

@media (max-width: 600px) {

  .wrapper {
    padding: 16px;
  }

  .diffOrgLogo,
  .tata_image {
    max-width: 160px;
    max-height: 40px;
  }

  .tata_image {
    height: 35px;
  }
}
</style>
